// // Create a booking context
// const BookingContext = createContext();

// export const BookingProvider = ({ children }) => {
//   const [needsRefresh, setNeedsRefresh] = useState(false);
  
//   return (
//     <BookingContext.Provider value={{ needsRefresh, setNeedsRefresh }}>
//       {children}
//     </BookingContext.Provider>
//   );
// };

// // Wrap your app/routes with <BookingProvider>












// // BookingProvider.js
// import { createContext, useState } from 'react';

// export const BookingContext = createContext();

// export const BookingProvider = ({ children }) => {
//   const [needsRefresh, setNeedsRefresh] = useState(false);
  
//   return (
//     <BookingContext.Provider value={{ needsRefresh, setNeedsRefresh }}>
//       {children}
//     </BookingContext.Provider>
//   );
// };





// context/BookingContext.js
import { createContext, useState, useEffect } from 'react';

export const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [needsRefresh, setNeedsRefresh] = useState(false);

  // Add debug logging
  useEffect(() => {
    console.log('BookingContext needsRefresh changed to:', needsRefresh);
  }, [needsRefresh]);

  return (
    <BookingContext.Provider value={{ needsRefresh, setNeedsRefresh }}>
      {children}
    </BookingContext.Provider>
  );
};